import { lazy } from 'react';

import type { User } from '@app/features/project/screens/Tasks/types';
import { ReactWebComponent } from '@app/utils/web-components';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const TasksPage = lazy(() => import('./pages/Tasks'));

class TasksDashboardWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['is-admin', 'project-id', 'branch', 'user', 'max-file-uploads'];
    }

    render() {
        const isAdmin = !!this.jsonProp('is-admin');
        const projectId = this.prop('project-id');
        const user = this.jsonProp('user') as User;
        const branch = this.prop('branch');
        const maxFileUploadsParamValue = this.getAttribute('max-file-uploads');
        let maxFileUploads;

        if (maxFileUploadsParamValue != null) {
            maxFileUploads = parseInt(maxFileUploadsParamValue, 10);
        }

        return (
            <RootProviders>
                <TasksPage
                    isAdmin={isAdmin}
                    projectId={projectId}
                    branch={branch}
                    user={user}
                    maxFileUploads={maxFileUploads}
                />
            </RootProviders>
        );
    }
}

customElements.define('tasks-dashboard', TasksDashboardWebComponent);
